import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { from } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { WindowWrapperService } from '@awin/shared';
import { AuthHelperService } from '@awin/shared/auth0-helper';
import { environment } from 'environments/environment';

@Component({
  template: '',
})
export class OidcComponent implements OnInit {
  constructor(
    private oAuthService: OAuthService,
    private route: ActivatedRoute,
    private windowWrapperService: WindowWrapperService,
    private authHelperService: AuthHelperService,
  ) {}

  ngOnInit(): void {
    from(this.oAuthService.tryLogin()).subscribe({
      next: () => {
      if (this.oAuthService.hasValidAccessToken()) {
        this.windowWrapperService.nativeWindow.location.href =
          decodeURIComponent(this.oAuthService.state);
      } else {
        const { locale, networkGroup } = this.route.snapshot.queryParams;
        const codeFlowParams = this.authHelperService.getCodeFlowParams(
          `/communication-centre/${locale}/${networkGroup}`,
          this.route,
          environment.name,
        );

        if (codeFlowParams) {
          this.oAuthService.initCodeFlow(...codeFlowParams);
        }
      }
    },
    error: (error: unknown) => console.error(error),
    });
  }
}
